/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable sonarjs/cognitive-complexity */
import { IPublicClientApplication } from "@azure/msal-browser";
import React, { ChangeEvent } from "react";
import {
    Button,
    Col,
    Container,
    OverlayTrigger,
    Row,
    Tooltip,
} from "react-bootstrap";

import { axiosGetRequest, axiosPutRequest } from "../../api/ApiClient";
import AutoCompleteClean from "../../components/AutoCompleteClean";
import Dialog from "../../components/Dialog";
import {
    InformationModalIcon,
    LessIcon,
    PlusIcon,
} from "../../components/Icons";
import InputLabelTextArea from "../../components/InputLabelTextArea";
import SelectOption from "../../model/SelectOption";
import {
    StyledDefaultButtonLink,
    inputNumberHourStyles,
} from "../../styles/pages/AcademicActivityPlanStyles";
import UploadFileStyles from "../../styles/pages/UploadFilesStyles";
import GenericUtils from "../../utils/GenericUtils";
import AcademicActivityPlansItem, {
    arraysEqual,
    getNumbersList,
} from "./AcademicActivityPlansTypes";
import DialogErrorStudentAssociado from "./DialogErrorStudentAssociado";
import {
    TipoHoraEnum,
    TipoHoraEnumLabel,
} from "../../model/Enums/TipoHoraEnum";
import InputSelect from "../../components/InputSelect";

const { StyledImportButton, StyledModalTitle, StyledModalText } =
    UploadFileStyles;

interface IProps {
    open: boolean;
    onHide: () => void;
    onOkClose: (value: AcademicActivityPlansItem) => void;
    period: string;
    teacher: any;
    activityValue: AcademicActivityPlansItem;
    activitiesList: any[];
    activitityPlansItems: any[];
    instanceMsal: IPublicClientApplication;
    workloadOriginal: number;
    workloadOriginalEventual: number;
    workloadOriginalSubstituicao: number;
    // eslint-disable-next-line react/no-unused-prop-types
    teachingActivity: any;
    isConsultProfile: boolean;
    isDACProfile: boolean;
}
interface IState {
    activitiesAutoCompleteList: SelectOption[];
    campusUpdateNeed: boolean;
    campusAutoCompleteList: SelectOption[];
    campusList: any[];
    coverageUpdateNeed: boolean;
    coverageAutoCompleteList: SelectOption[];
    coverageList: any[];
    studentUpdateNeed: boolean;
    studentIdAutoCompletList: SelectOption[];
    studentNameAutoCompletList: SelectOption[];
    studentList: any[];
    timeTypeAutoCompleteList: SelectOption[];
    timeTypeList: any[];
    numberAutoCompleteList: SelectOption[];
    accessToken: string;
    isStudentsEdit: boolean;
    isDetailingMandatory: boolean;
    isDetailingReadonly: boolean;
    selectedActivity: SelectOption;
    selectedCampus: SelectOption;
    selectedDetailing: string;
    selectedTypeHour: SelectOption;
    selectedNumberOfHour: SelectOption;
    selectedCoverage: SelectOption;
    selectedStudentsId: SelectOption[];
    selectedStudentsName: SelectOption[];
    studentsForm: any[];
    studentsBtnAddEnabled: boolean;
    modalErrorStudentAssociado: boolean;
    activityTooltip: string;
    tableIndex: number;
    modalErrorText: string;
    showModalError: boolean;
    isFormValid: boolean;
}

function getNewEmptyStudent() {
    const newValue = {
        estudanteId: 0,
        centroResultadoId: 0,
        nome: "",
        cpf: "",
        passaporte: "",
        matricula: "",
    };
    return { ...newValue };
}
interface DialogErroMessageProps {
    show: boolean;
    message: string;
    actionHide: () => void;
    actionClose: (event: any) => void;
}

function DialogErrorMessage({
    show,
    message,
    actionClose,
    actionHide,
}: DialogErroMessageProps) {
    return (
        <Dialog
            openModal={show}
            onHide={actionHide}
            modalIcon={<InformationModalIcon />}
        >
            <StyledModalText>{message}</StyledModalText>

            <StyledImportButton
                style={{ width: 84, marginTop: 24 }}
                onClick={actionClose}
            >
                OK
            </StyledImportButton>
        </Dialog>
    );
}

export default class EditAcademicActivity extends React.Component<
    IProps,
    IState
> {
    constructor(props: IProps | Readonly<IProps>) {
        super(props);
        this.state = {
            timeTypeAutoCompleteList: [],
            timeTypeList: [],
            activitiesAutoCompleteList: [],
            campusUpdateNeed: false,
            campusAutoCompleteList: [],
            campusList: [],
            coverageUpdateNeed: false,
            coverageAutoCompleteList: [],
            studentUpdateNeed: false,
            coverageList: [],
            studentIdAutoCompletList: [],
            studentNameAutoCompletList: [],
            studentList: [],
            numberAutoCompleteList: [],
            accessToken: GenericUtils.getAccessTokenDocente(),
            isStudentsEdit: false,
            isDetailingMandatory: false,
            isDetailingReadonly: false,
            selectedActivity: {
                label: "",
                value: "",
            },
            selectedCampus: {
                label: "",
                value: "",
            },
            selectedCoverage: {
                label: "",
                value: "",
            },
            selectedDetailing: "",
            selectedTypeHour: {
                label: "",
                value: "",
            },
            selectedNumberOfHour: {
                label: "Hora / Aula",
                value: "",
            },
            selectedStudentsId: [
                {
                    label: "",
                    value: "",
                },
            ],
            selectedStudentsName: [
                {
                    label: "",
                    value: "",
                },
            ],
            studentsForm: [
                {
                    estudanteId: 0,
                    centroResultadoId: 0,
                    nome: "",
                    cpf: "",
                    passaporte: "",
                    matricula: "",
                },
            ],
            studentsBtnAddEnabled: false,
            modalErrorStudentAssociado: false,
            activityTooltip: "Atividade",
            tableIndex: -1,
            showModalError: false,
            modalErrorText: "",
            isFormValid: false,
        };
    }

    async componentDidUpdate(
        prevProps: Readonly<IProps>,
        prevStates: Readonly<IState>
    ) {
        await this.getTimeTypes();
        this.getNumbers();

        this.configureActivetyValues(prevProps, prevStates);
    }

    handleCloseDialogErrorStudentAssociado() {
        this.setState({
            modalErrorStudentAssociado: false,
        });
    }

    handleTimeSelectChange = (selectedTypeHourParam: any[]) => {
        const sel = selectedTypeHourParam[0];

        if (sel === undefined) {
            this.setState({
                selectedTypeHour: {
                    label: "",
                    value: "",
                },
            });
        } else {
            this.setState({
                selectedTypeHour: sel,
            });
        }
    };

    handleCampusSelectChange = (selectedCampusParam: any[]) => {
        const sel = selectedCampusParam[0];

        if (sel === undefined) {
            this.setState({
                selectedCampus: {
                    label: "",
                    value: "",
                },
            });
        } else {
            this.setState({
                selectedCampus: {
                    label: sel.label,
                    value: sel.value,
                },
            });
        }

        setTimeout(() => {
            this.getCoverages().then((_) => {
                this.handleCoverageSelectChange([]);
            });
        }, 200);
    };

    handleCoverageSelectChange = (selectedCovarageParam: any[]) => {
        const sel = selectedCovarageParam[0];

        if (sel === undefined) {
            this.setState({
                selectedCoverage: {
                    label: "",
                    value: "",
                },
            });
        } else {
            this.setState({
                selectedCoverage: {
                    label: sel.label,
                    value: sel.value,
                },
            });
        }

        setTimeout(() => {
            this.getStudents().then((_) => {
                this.resetStudentSelects();
            });
        }, 200);
    };

    handleNumbersSelectChange = (event: ChangeEvent<{ value: unknown }>) => {
        const selectedValue = event.target.value as string;

        if (selectedValue === undefined) {
            this.setState({
                selectedNumberOfHour: {
                    label: "",
                    value: "",
                },
            });
        } else {
            this.setState({
                selectedNumberOfHour: {
                    label: selectedValue,
                    value: selectedValue,
                },
            });
        }
    };

    handleChangeSelectedActivity = (selectedActivity: any[] | string) => {
        const sel = selectedActivity[0];

        const isValueChanged = sel === undefined;

        const activityValue = this.findActivityById(sel?.value);

        if (!activityValue) {
            this.setSelectedDetailing("");
        } else {
            this.setSelectedDetailing(
                activityValue?.atividadeDetalhamentoDescricao
            );
        }
        const selectedActivityAndConfigurations =
            this.getSelectedActivityAndConfigurations(
                isValueChanged,
                sel?.value,
                activityValue?.atividadeDetalhamentoDescricao,
                {}
            );

        this.setState(
            {
                ...selectedActivityAndConfigurations,
            },
            () => {
                setTimeout(() => {
                    this.getCampus().then((_) => {
                        this.handleCampusSelectChange([]);
                        if (!this.state.selectedActivity) {
                            this.setSelectedDetailing("");
                        }
                    });
                }, 200);
            }
        );
    };

    handleChangeActivityAutoComplete = (
        text: string,
        _event: ChangeEvent<HTMLInputElement>
    ) => {
        const sel = undefined;

        if (sel === undefined) {
            this.setState({
                selectedActivity: {
                    label: text,
                    value: "",
                },
            });
        }
    };

    handleTextAreaChangeEdit = (event: ChangeEvent<{ value: any }>) => {
        const arraySelect = event?.target?.value;

        if (arraySelect === undefined) {
            this.setState({
                selectedDetailing: "",
            });
        } else {
            this.setSelectedDetailing(arraySelect);
        }
    };

    private setSelectedDetailing(value: any) {
        this.setState({
            selectedDetailing: value as string,
        });
    }

    getNumbers() {
        const { numberAutoCompleteList } = this.state;
        if (numberAutoCompleteList.length !== 0) {
            return;
        }
        this.setState({
            numberAutoCompleteList: getNumbersList(),
        });
    }

    async getTimeTypes() {
        const { accessToken } = this.state;
        const { instanceMsal } = this.props;
        const { timeTypeList } = this.state;
        if (timeTypeList.length !== 0) {
            return;
        }

        const newPeriods: any[] = [
            {
                value: "",
                label: "Tipo de hora",
            },
        ];

        const response = await axiosGetRequest(
            "/docente/v1/planosatividade/tipos-hora",
            accessToken,
            instanceMsal
        );

        if (GenericUtils.isSuccessStatus(response)) {
            response.data.map((data: any) =>
                newPeriods.push({
                    value: data.tipoHoraId,
                    label: data.tipoHoraDescricao,
                })
            );

            this.setState({ timeTypeList: response.data });
            this.setState({ timeTypeAutoCompleteList: newPeriods });
        }
    }

    async getCampus(): Promise<SelectOption[]> {
        const newCampus = new Array<SelectOption>();
        const { accessToken, selectedActivity } = this.state;
        const { instanceMsal } = this.props;

        if (!selectedActivity?.value) {
            return [];
        }

        const response = await axiosGetRequest(
            `/docente/v1/centros-resultado/atividades/${selectedActivity?.value}/campus`,
            accessToken,
            instanceMsal
        );

        response.data.map((data: any) =>
            newCampus.push({
                value: data,
                label: data,
            })
        );

        this.setState({
            campusList: response.data,
            campusAutoCompleteList: newCampus,
        });
        return newCampus;
    }

    async getCoverages(): Promise<SelectOption[]> {
        const newCovarages = new Array<SelectOption>();
        const { accessToken, selectedActivity, selectedCampus } = this.state;
        const { instanceMsal } = this.props;

        if (!selectedActivity?.value || !selectedCampus.value) {
            return [];
        }

        const response = await axiosGetRequest(
            `/docente/v1/centros-resultado/atividades/${selectedActivity?.value}/campus/${selectedCampus.value}`,
            accessToken,
            instanceMsal
        );

        response.data.map((data: any) =>
            newCovarages.push({
                value: data.centroResultadoId,
                label: data.nome,
            })
        );

        await this.setState({
            coverageList: response.data,
            coverageAutoCompleteList: newCovarages,
        });
        return newCovarages;
    }

    async getStudents(): Promise<{
        studentList: [];
        studentIdAutoCompletList: SelectOption[];
        studentNameAutoCompletList: SelectOption[];
    }> {
        const newStudentsId = new Array<SelectOption>();
        const newStudentsName = new Array<SelectOption>();
        const { accessToken, selectedCoverage } = this.state;
        const { instanceMsal } = this.props;

        if (!selectedCoverage?.value) {
            return {
                studentList: [],
                studentIdAutoCompletList: [],
                studentNameAutoCompletList: [],
            };
        }

        const response = await axiosGetRequest(
            `/docente/v1/estudantes/${selectedCoverage.value}`,
            accessToken,
            instanceMsal
        );

        if (response.data) {
            response.data.forEach((data: any) =>
                newStudentsName.push({
                    value: data?.cpf !== "" ? data.cpf : data.passaporte,
                    label: data.nome,
                })
            );
        }

        if (response.data) {
            response.data.forEach((data: any) =>
                newStudentsId.push({
                    value: data.nome,
                    label: data?.cpf !== "" ? data.cpf : data.passaporte,
                })
            );
        }

        this.setState({
            studentList: response.data,
            studentIdAutoCompletList: newStudentsId,
            studentNameAutoCompletList: newStudentsName,
        });
        return {
            studentList: response.data,
            studentIdAutoCompletList: newStudentsId,
            studentNameAutoCompletList: newStudentsName,
        };
    }

    private getSelectedActivityAndConfigurations(
        getDefaultValue: boolean,
        activityId: string,
        detailingValue: string,
        extraValues: Record<string, any>
    ): {
        selectedActivity: SelectOption;
        isStudentsEdit: boolean;
        isDetailingMandatory: boolean;
    } {
        const result = {
            ...extraValues,
            selectedActivity: {
                value: "",
                label: "",
            },
            isStudentsEdit: false,
            isDetailingMandatory: false,
            isDetailingReadonly: false,
            activityTooltip: "Atividade",
        };
        if (!getDefaultValue) {
            const findActivity = this.findActivityById(activityId);
            if (findActivity) {
                result.selectedActivity = {
                    value: findActivity.atividadeId,
                    label: findActivity.descricaoAtividade,
                };
                result.isStudentsEdit = findActivity.temEstudante === "S";
                result.isDetailingMandatory =
                    findActivity.detalhamentoObrigatorio === "S";
                result.isDetailingReadonly =
                    result.isDetailingMandatory && detailingValue.length > 0;

                result.activityTooltip =
                    findActivity.descricaoExplicativa || "Atividade";
            }
        }

        return result;
    }

    handleStudentsIdSelectChange = (e: any[], index: number) => {
        let modalErrorStudentAssociadoValue = false;
        if (
            this.state.selectedStudentsId.find((value) => {
                return value?.label === e[0]?.label;
            })
        ) {
            modalErrorStudentAssociadoValue = true;
        }
        if (e[0]?.label !== "" && !modalErrorStudentAssociadoValue) {
            this.validStudentUse(index, e[0]?.label);
        }
        this.configureStudentsSelectByIdEvent(
            e,
            modalErrorStudentAssociadoValue,
            index
        );
    };

    handleStudentsNameSelectChange = (e: any[], index: number) => {
        let modalErrorStudentAssociadoValue = false;
        if (
            this.state.selectedStudentsId.find((value) => {
                return value?.label === e[0]?.value;
            })
        ) {
            modalErrorStudentAssociadoValue = true;
        }
        if (e[0]?.label !== "" && !modalErrorStudentAssociadoValue) {
            this.validStudentUse(index, e[0]?.value);
        }
        this.configureStudentsSelectByNameEvent(
            e,
            modalErrorStudentAssociadoValue,
            index
        );
    };

    static getStudentsBtnAddEnabled(list: any[]): boolean {
        let result = list.length !== 0;
        list.forEach((value) => {
            if (value?.cpf === "") {
                result = false;
            }
        });
        return result;
    }

    getWorkLoadByType(typeHour: string): number {
        if (
            typeHour.toLowerCase() ===
            TipoHoraEnumLabel.get(TipoHoraEnum.Normal)?.toLowerCase()
        )
            return this.props.workloadOriginal;

        if (
            typeHour.toLowerCase() ===
            TipoHoraEnumLabel.get(TipoHoraEnum.Eventual)?.toLowerCase()
        )
            return this.props.workloadOriginalEventual;

        if (
            typeHour.toLowerCase() ===
            TipoHoraEnumLabel.get(TipoHoraEnum.Substituicao)?.toLowerCase()
        )
            return this.props.workloadOriginalSubstituicao;

        return 0;
    }

    resetStudentSelects = () => {
        this.setState({
            studentsForm: [getNewEmptyStudent()],
            selectedStudentsId: [
                {
                    value: "",
                    label: "",
                },
            ],
            selectedStudentsName: [
                {
                    value: "",
                    label: "",
                },
            ],
        });
    };

    handleClickPlusEdit = () => {
        const { studentsForm, selectedStudentsId, selectedStudentsName } =
            this.state;
        const newStudentsForm = [...studentsForm];
        const newSelectedStudentsId = [...selectedStudentsId];
        const newSelectedStudentsName = [...selectedStudentsName];
        newStudentsForm.push(getNewEmptyStudent());
        newSelectedStudentsId.push({
            value: "",
            label: "",
        });
        newSelectedStudentsName.push({
            value: "",
            label: "",
        });
        this.setState({
            studentsForm: newStudentsForm,
            selectedStudentsId: newSelectedStudentsId,
            selectedStudentsName: newSelectedStudentsName,
        });
    };

    handleClickLessEdit = (index: number) => {
        const { studentsForm, selectedStudentsId, selectedStudentsName } =
            this.state;
        const newStudentsForm = [...studentsForm];
        const newSelectedStudentsId = [...selectedStudentsId];
        const newSelectedStudentsName = [...selectedStudentsName];

        newStudentsForm.splice(index, 1);
        newSelectedStudentsId.splice(index, 1);
        newSelectedStudentsName.splice(index, 1);

        this.setState({
            studentsForm: newStudentsForm,
            selectedStudentsId: newSelectedStudentsId,
            selectedStudentsName: newSelectedStudentsName,
        });
    };

    private configureStudentsSelectByIdEvent(
        e: any[],
        modalErrorStudentAssociadoValue: boolean,
        index: number
    ) {
        const {
            studentsForm,
            studentList,
            selectedStudentsId,
            selectedStudentsName,
        } = this.state;
        const newSelectedStudentsId = [...selectedStudentsId];
        const newSelectedStudentsName = [...selectedStudentsName];
        const newStudentsForm = [...studentsForm];

        let eventValueId = e[0];
        let eventValueName = {
            label: e[0]?.value || "",
            value: e[0]?.label || "",
        };

        if (eventValueId && !modalErrorStudentAssociadoValue) {
            const updateStudent = studentList.find(
                (studentValue) => studentValue.cpf === eventValueId.label
            );
            newStudentsForm[index] = updateStudent;
        } else {
            eventValueId = {
                value: "",
                label: "",
            };
            eventValueName = {
                value: "",
                label: "",
            };
            newStudentsForm[index] = getNewEmptyStudent();
        }

        newSelectedStudentsId[index] = eventValueId;
        newSelectedStudentsName[index] = eventValueName;

        this.setState({
            selectedStudentsId: newSelectedStudentsId,
            selectedStudentsName: newSelectedStudentsName,
            studentsForm: newStudentsForm,
            studentsBtnAddEnabled:
                EditAcademicActivity.getStudentsBtnAddEnabled(newStudentsForm),
            modalErrorStudentAssociado: modalErrorStudentAssociadoValue,
        });
    }

    private configureStudentsSelectByNameEvent(
        e: any[],
        modalErrorStudentAssociadoValue: boolean,
        index: number
    ) {
        const {
            studentsForm,
            studentList,
            selectedStudentsId,
            selectedStudentsName,
        } = this.state;
        const newSelectedStudentsId = [...selectedStudentsId];
        const newSelectedStudentsName = [...selectedStudentsName];
        const newStudentsForm = [...studentsForm];

        let eventValueName = e[0];
        let eventValueId = {
            label: e[0]?.value || "",
            value: e[0]?.label || "",
        };

        if (eventValueName && !modalErrorStudentAssociadoValue) {
            const updateStudent = studentList.find(
                (studentValue) => studentValue.cpf === eventValueName.value
            );
            newStudentsForm[index] = updateStudent;
        } else {
            eventValueName = {
                value: "",
                label: "",
            };
            eventValueId = {
                value: "",
                label: "",
            };
            newStudentsForm[index] = getNewEmptyStudent();
        }

        newSelectedStudentsId[index] = eventValueId;
        newSelectedStudentsName[index] = eventValueName;

        this.setState({
            selectedStudentsId: newSelectedStudentsId,
            selectedStudentsName: newSelectedStudentsName,
            studentsForm: newStudentsForm,
            studentsBtnAddEnabled:
                EditAcademicActivity.getStudentsBtnAddEnabled(newStudentsForm),
            modalErrorStudentAssociado: modalErrorStudentAssociadoValue,
        });
    }

    async putStudentValidate(params: any): Promise<boolean> {
        const response = await axiosPutRequest(
            `docente/v1/estudantes/${params.estudanteId}/validacao`,
            params,
            this.state.accessToken,
            this.props.instanceMsal
        );

        if (response.data.code === 500) {
            this.actionShowModalError(response.data.details);
            return false;
        }

        if (response.data.code === 400) {
            this.actionShowModalError(response.data.details);
            return false;
        }

        return true;
    }

    actionShowModalError(msg: string) {
        this.setState({
            modalErrorText: msg,
            showModalError: true,
        });
    }

    validStudentUse(index: number, cpf: number): any {
        if (!cpf) {
            return;
        }
        const findStudent = this.state.studentList.find(
            (value) => value.cpf === cpf
        );

        const paramValid = {
            estudanteId: findStudent.estudanteId,
            atividadeId: this.state.selectedActivity.value,
            campus: this.state.selectedCampus.value,
            abrangencia: this.state.selectedCoverage?.label,
            vigenciaId: this.props.period,
            docenteId: this.props.teacher.docenteID,
        };
        this.putStudentValidate(paramValid).then((result) => {
            if (!result) {
                this.configureStudentsSelectByIdEvent(
                    [{ value: "", label: "" }],
                    false,
                    index
                );
                this.configureStudentsSelectByNameEvent(
                    [{ value: "", label: "" }],
                    false,
                    index
                );
            } else {
                const existsInPlan =
                    this.checkStudentExistsInLocalAcitivityPlan(paramValid);
                if (existsInPlan) {
                    this.configureStudentsSelectByIdEvent(
                        [{ value: "", label: "" }],
                        false,
                        index
                    );
                    this.configureStudentsSelectByNameEvent(
                        [{ value: "", label: "" }],
                        false,
                        index
                    );
                }
            }
        });
    }

    checkStudentExistsInLocalAcitivityPlan(paramValid: {
        estudanteId: any;
        atividadeId: any;
        campus: any;
        docenteId: any;
        abrangencia: any;
        vigenciaId: string;
    }) {
        let existsStudentInLocalPlan = false;
        const activityValue = this.props.activitityPlansItems.find(
            (value) => value.activity.atividadeId === paramValid.atividadeId
        );
        if (activityValue) {
            const valueStudents = activityValue.students.find(
                (valueFind: any) =>
                    valueFind.estudanteId === paramValid.estudanteId
            );
            if (
                valueStudents &&
                activityValue.activity.atividadeId !== paramValid.atividadeId
            ) {
                this.actionShowModalError(
                    `O estudante ${valueStudents.nome} já está vinculado à essa atividade neste TACH.`
                );
                existsStudentInLocalPlan = true;
            }
        }
        return existsStudentInLocalPlan;
    }

    private findActivityById(value: string) {
        if (!value) {
            return null;
        }

        const activity = this.props.activitiesList.find(
            (activityFind) => activityFind.atividadeId === value
        );
        if (activity) {
            return activity;
        }
        if (this.props.activityValue.activity.atividadeId === value) {
            return this.props.activityValue.activity;
        }
        return null;
    }

    async configureActivetyValues(
        prevProps: Readonly<IProps>,
        prevStates: Readonly<IState>
    ) {
        this.configureSelectedTypeHour(prevProps, prevStates);
        this.configureSelectedNumber(prevProps, prevStates);
        this.configureSelectedDetailing(prevProps, prevStates);
        this.configureSelectedActivity(prevProps, prevStates);
    }

    private configureSelectedNumber(
        prevProps: Readonly<IProps>,
        _prevStates: Readonly<IState>
    ) {
        const hour = `${this.props.activityValue?.hour}`;
        if (prevProps.activityValue?.hour === this.props.activityValue?.hour) {
            return;
        }
        let selectedValueNumber = {
            value: "",
            label: "",
        };

        const find = this.state.numberAutoCompleteList.find(
            (value) => value.value === hour
        );

        if (find) {
            selectedValueNumber = find;
        }

        this.setState({ selectedNumberOfHour: selectedValueNumber });
    }

    private configureSelectedTypeHour(
        prevProps: Readonly<IProps>,
        _prevStates: Readonly<IState>
    ) {
        if (
            prevProps.activityValue?.typeHour ===
                this.props.activityValue?.typeHour &&
            this.props.activityValue?.typeHour ===
                this.state.selectedTypeHour.label
        ) {
            return;
        }

        let selectedValueTypeHour = {
            value: "",
            label: "",
        };

        const find = this.state.timeTypeAutoCompleteList.find(
            (value) => value.label === this.props.activityValue?.typeHour
        );

        if (find) {
            selectedValueTypeHour = find;
            /* {
                label: this.props.activityValue?.typeHour,
                value: this.props.activityValue?.typeHour,
            }; */
        }

        this.setState({ selectedTypeHour: selectedValueTypeHour });
    }

    private configureSelectedDetailing(
        prevProps: Readonly<IProps>,
        _prevStates: Readonly<IState>
    ) {
        const detailing = this.props.activityValue?.detailing;
        if (
            prevProps.activityValue?.detailing ===
            this.props.activityValue?.detailing
        ) {
            return;
        }

        this.setState({ selectedDetailing: detailing });
    }

    private configureSelectedActivity(
        prevProps: Readonly<IProps>,
        prevStates: Readonly<IState>
    ) {
        if (
            prevProps.activityValue?.tableIndex ===
            this.props.activityValue?.tableIndex
        ) {
            return;
        }

        if (this.state.activitiesAutoCompleteList.length === 0) {
            const newActivity = new Array<SelectOption>();
            this.props.activitiesList.forEach((data: any) =>
                newActivity.push({
                    value: data.atividadeId,
                    label: data.descricaoAtividade,
                })
            );
            const find = this.props.activitiesList.find(
                (value) =>
                    value.atividadeId ===
                    this.props.activityValue.activity.atividadeId
            );
            if (!find) {
                newActivity.push({
                    value: this.props.activityValue.activity.atividadeId,
                    label: this.props.activityValue.activity.descricaoAtividade,
                });
            }

            this.setState({
                activitiesAutoCompleteList: newActivity,
            });
        }

        const isValueChanged =
            this.props.activityValue?.tableIndex !== this.state.tableIndex;
        const selectedActivityAndConfigurations =
            this.getSelectedActivityAndConfigurations(
                !isValueChanged,
                this.props.activityValue?.activity?.atividadeId,
                this.props.activityValue.detailing,
                {
                    campusUpdateNeed: true,
                    tableIndex: this.props.activityValue?.tableIndex,
                }
            );

        this.setState(
            {
                ...selectedActivityAndConfigurations,
            },
            () => {
                this.configureSelectedCampus(prevProps, prevStates);
            }
        );
    }

    private updateCampusData(
        prevProps: Readonly<IProps>,
        campusAutoCompleteList: SelectOption[],
        prevStates: Readonly<IState>
    ) {
        const prevTableIndex = `${prevProps.activityValue?.tableIndex}`;
        const prevActivityId = prevProps.activityValue?.activity?.atividadeId;
        const prevPropsCampus = prevProps.activityValue?.campus;
        const propsTableIndex = `${this.props.activityValue?.tableIndex}`;
        const propsActivityId = this.props.activityValue?.activity?.atividadeId;
        const propsCampus = this.props.activityValue?.campus;
        const { campusUpdateNeed } = this.state;

        if (
            (propsTableIndex + propsActivityId + prevPropsCampus ===
                prevTableIndex + prevActivityId + propsCampus &&
                !campusUpdateNeed) ||
            !campusUpdateNeed
        ) {
            return;
        }

        let selectedCampusValue = {
            label: "",
            value: "",
        };

        const find = campusAutoCompleteList.find(
            (value) => value.value === propsCampus
        );

        if (find) {
            selectedCampusValue = find;
        }
        this.setState(
            {
                selectedCampus: selectedCampusValue,
                campusUpdateNeed: false,
                coverageUpdateNeed: true,
            },
            () => {
                this.configureSelectedCoverage(prevProps, prevStates);
            }
        );
    }

    private async configureSelectedCampus(
        prevProps: Readonly<IProps>,
        prevStates: Readonly<IState>
    ) {
        const { campusUpdateNeed, campusAutoCompleteList } = this.state;
        if (campusUpdateNeed) {
            this.getCampus().then((data) => {
                this.updateCampusData(prevProps, data, prevStates);
            });
        } else {
            this.updateCampusData(
                prevProps,
                campusAutoCompleteList,
                prevStates
            );
        }
    }

    private async configureSelectedCoverage(
        prevProps: Readonly<IProps>,
        prevStates: Readonly<IState>
    ) {
        const { coverageUpdateNeed, coverageAutoCompleteList } = this.state;
        if (coverageUpdateNeed) {
            this.getCoverages().then((data) => {
                this.updateCoverageData(prevProps, data, prevStates);
            });
        } else {
            this.updateCoverageData(
                prevProps,
                coverageAutoCompleteList,
                prevStates
            );
        }
    }

    private updateCoverageData(
        prevProps: Readonly<IProps>,
        coverageAutoCompleteList: SelectOption[],
        prevStates: Readonly<IState>
    ) {
        const prevTableIndex = `${prevProps.activityValue?.tableIndex}`;
        const prevActivityId = prevProps.activityValue?.activity?.atividadeId;
        const propsTableIndex = `${this.props.activityValue?.tableIndex}`;
        const propsActivityId = this.props.activityValue?.activity?.atividadeId;
        const prevPropsCoverage = prevProps.activityValue?.coverage?.nome;
        const propsCoverage = this.props.activityValue?.coverage?.nome;
        const { coverageUpdateNeed } = this.state;

        if (
            (prevTableIndex + prevActivityId + prevPropsCoverage ===
                propsTableIndex + propsActivityId + propsCoverage &&
                !coverageUpdateNeed) ||
            !coverageUpdateNeed
        ) {
            return;
        }

        let selectedCovarageValue = {
            label: "",
            value: "",
        };

        const find = coverageAutoCompleteList.find(
            (value) => value.label === propsCoverage
        );

        if (find) {
            selectedCovarageValue = find;
        }
        this.setState(
            {
                selectedCoverage: selectedCovarageValue,
                studentUpdateNeed: true,
                coverageUpdateNeed: false,
            },
            () => {
                this.configureSelectedStudens(prevProps, prevStates);
            }
        );
    }

    saveSelectedActivity() {
        const selectedActivityReturn: AcademicActivityPlansItem = {
            activity: this.findActivityById(this.state.selectedActivity.value),
            campus: this.state.selectedCampus,
            coverage: {
                centroResultadoId: this.state.selectedCoverage.value,
                nome: this.state.selectedCoverage.label,
            },
            detailing: this.state.selectedDetailing,
            hour: this.state.selectedNumberOfHour,
            id: this.props.activityValue.id,
            students: this.state.studentsForm.filter(
                (value) => value && value!.nome !== ""
            ),
            typeHour: this.state.selectedTypeHour,
            dataVigenciaInicio: this.props.activityValue.dataVigenciaInicio,
            dataVigenciaFim: this.props.activityValue.dataVigenciaFim,
            workloadValid: this.props.activityValue.workloadValid,
            hoursBookings: this.props.activityValue.hoursBookings,
            tableIndex: this.props.activityValue.tableIndex,
        };

        const activitiesAux = this.props.activitityPlansItems.filter(
            (value) =>
                value.tableIndex !== this.props.activityValue.tableIndex &&
                value.typeHour === this.props.activityValue.typeHour
        );
        let hoursUsedWithOutEdited = 0;
        activitiesAux.forEach((value) => {
            hoursUsedWithOutEdited += Number(value.hour);
        });

        if (
            Number(this.state.selectedNumberOfHour.value) +
                hoursUsedWithOutEdited <=
            this.getWorkLoadByType(this.props.activityValue.typeHour)
        ) {
            this.handleChangeSelectedActivity([]);
        }
        this.props.onOkClose(selectedActivityReturn);
    }

    private async configureSelectedStudens(
        prevProps: Readonly<IProps>,
        _prevStates: Readonly<IState>
    ) {
        const temEstudante = this.props.activityValue?.activity?.temEstudante;
        if (temEstudante === "N") {
            return;
        }
        let { studentIdAutoCompletList, studentNameAutoCompletList } =
            this.state;
        const prevPropsStudents = prevProps?.activityValue?.students
            ? [...prevProps.activityValue.students]
            : [];
        const propsStudentes = this.props?.activityValue?.students
            ? [...this.props.activityValue.students]
            : [];
        const { studentUpdateNeed } = this.state;

        if (this.state.studentUpdateNeed) {
            const result = await this.getStudents();
            studentIdAutoCompletList = result.studentIdAutoCompletList;
            studentNameAutoCompletList = result.studentNameAutoCompletList;
        }

        if (
            (arraysEqual(prevPropsStudents, propsStudentes) &&
                !studentUpdateNeed) ||
            !studentUpdateNeed
        ) {
            return;
        }
        const newStudentsForm = [...propsStudentes].filter(
            (student) => student.ativo
        );
        if (!newStudentsForm || newStudentsForm.length === 0) {
            newStudentsForm.push(getNewEmptyStudent());
        }
        const newSelectedStudentsId: any[] = [];
        const newSelectedStudentsName: any[] = [];
        newStudentsForm.forEach((student) => {
            const studentFindId = studentIdAutoCompletList.find(
                (value) => value.label === student.cpf
            );
            if (studentFindId) {
                newSelectedStudentsId.push(studentFindId);
            }
            const studentFindName = studentNameAutoCompletList.find(
                (value) => value.value === student.cpf
            );
            if (studentFindName) {
                newSelectedStudentsName.push(studentFindName);
            }
        });

        if (newSelectedStudentsId.length === 0) {
            newSelectedStudentsId.push({
                label: "",
                value: "",
            });
        }

        if (newSelectedStudentsName.length === 0) {
            newSelectedStudentsName.push({
                label: "",
                value: "",
            });
        }
        this.setState({
            selectedStudentsId: newSelectedStudentsId,
            selectedStudentsName: newSelectedStudentsName,
            studentsForm: newStudentsForm,
            studentsBtnAddEnabled:
                EditAcademicActivity.getStudentsBtnAddEnabled(newStudentsForm),
            studentUpdateNeed: false,
        });
    }

    actionCloseDialogErrorMessage(_event: any) {
        this.actionHideDialogErroHide();
    }

    actionHideDialogErroHide() {
        this.setState({
            showModalError: false,
            modalErrorText: "",
        });
    }

    render() {
        if (!this.state) {
            return null;
        }
        const { onHide, activityValue, open, isConsultProfile, isDACProfile } =
            this.props;
        const {
            activitiesAutoCompleteList,
            campusAutoCompleteList,
            timeTypeAutoCompleteList,
            numberAutoCompleteList,
            coverageAutoCompleteList,
            selectedActivity,
            selectedCampus,
            selectedCoverage,
            selectedTypeHour,
            selectedNumberOfHour,
            isStudentsEdit,
            selectedStudentsId,
            selectedStudentsName,
            selectedDetailing,
            studentsForm,
            studentsBtnAddEnabled,
            studentNameAutoCompletList,
            studentIdAutoCompletList,
            isDetailingReadonly,
            isDetailingMandatory,
            activityTooltip,
            modalErrorStudentAssociado,
            showModalError,
            modalErrorText,
        } = this.state;

        // const studentsBlank = studentsForm.filter(
        //     (student: any) => student?.nome === ""
        // );

        const isValidSelectedActivity = selectedActivity.value !== "";
        const isValidSelectedNumberOfHours = selectedNumberOfHour.value !== "";
        const isValidSelectedCampus = selectedCampus.value !== "";
        const isValidselectedCoverage = selectedCoverage.value !== "";
        // const teachingActivity = this.props?.teachingActivity;
        // const isRascunhoInitial =
        //     !teachingActivity?.id ||
        //     (teachingActivity?.planoAtividadeStatusIdAtual
        //         ?.planoAtividadeStatusId ===
        //         PlanoAtividadeStatusEnum.Rascunho &&
        //         !teachingActivity?.planoAtividadeStatusIdAnterior) ||
        //     !(
        //         teachingActivity?.planoAtividadeStatusIdAnterior
        //             ?.planoAtividadeStatusId ===
        //             PlanoAtividadeStatusEnum.Aprovado ||
        //         teachingActivity.planoAtividadeStatusIdAnterior
        //             ?.planoAtividadeStatusId ===
        //             PlanoAtividadeStatusEnum.Inconsistente ||
        //         teachingActivity?.planoAtividadeStatusIdAtual
        //             ?.planoAtividadeStatusId ===
        //             PlanoAtividadeStatusEnum.Aprovado
        //     );
        // const isValidStudents =
        //     (studentsBlank.length === 0 && isStudentsEdit) ||
        //     !isStudentsEdit ||
        //     isRascunhoInitial;
        const isValidDetailing =
            (isDetailingMandatory && selectedDetailing !== "") ||
            !isDetailingMandatory;

        const isFormValidValue =
            isValidSelectedActivity &&
            isValidSelectedNumberOfHours &&
            isValidSelectedCampus &&
            isValidselectedCoverage &&
            isValidDetailing;

        const width = "100%";

        return (
            <div>
                <Dialog openModal={open} onHide={onHide} size="lg">
                    <StyledModalTitle style={{ paddingBottom: 48 }}>
                        {isConsultProfile
                            ? "Visualizar atividade"
                            : "Editar atividade"}
                    </StyledModalTitle>
                    <Container>
                        <Row>
                            <Col>
                                <OverlayTrigger
                                    placement="auto"
                                    overlay={
                                        <Tooltip placement="top-end">
                                            {activityTooltip}
                                        </Tooltip>
                                    }
                                >
                                    <Button
                                        style={{
                                            padding: 0,
                                            marginBottom: 0,
                                            border: 0,
                                            width: "100%",
                                        }}
                                    >
                                        <AutoCompleteClean
                                            id="editActivity"
                                            onChange={(e: string | any[]) =>
                                                this.handleChangeSelectedActivity(
                                                    e
                                                )
                                            }
                                            options={activitiesAutoCompleteList}
                                            key={selectedActivity?.value}
                                            defaultSelected={[selectedActivity]}
                                            disabled={
                                                isDACProfile
                                                    ? false
                                                    : activityValue?.workloadValid ||
                                                      isConsultProfile
                                            }
                                            label="Atividade"
                                            placeholder="Atividade"
                                            style={{
                                                marginBottom: 0,
                                            }}
                                        />
                                    </Button>
                                </OverlayTrigger>
                            </Col>
                            <Col>
                                <AutoCompleteClean
                                    options={timeTypeAutoCompleteList}
                                    onChange={this.handleTimeSelectChange}
                                    selected={[selectedTypeHour]}
                                    placeholder="Tipo de hora"
                                    disabled
                                    label="Tipo de hora"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <InputSelect
                                    optionsSelect={numberAutoCompleteList}
                                    value={
                                        this.state.selectedNumberOfHour?.value
                                    }
                                    handleSelectChange={
                                        this.handleNumbersSelectChange
                                    }
                                    style={inputNumberHourStyles({ width })}
                                    label="Hora / Aula"
                                    floatLabel
                                    disabled={
                                        isDACProfile
                                            ? false
                                            : activityValue?.workloadValid ||
                                              isConsultProfile
                                    }
                                />
                            </Col>
                            <Col>
                                <AutoCompleteClean
                                    onChange={this.handleCampusSelectChange}
                                    options={campusAutoCompleteList}
                                    placeholder="Campus"
                                    defaultSelected={[selectedCampus]}
                                    key={selectedCampus.value}
                                    disabled={
                                        isDACProfile
                                            ? false
                                            : selectedActivity.value === "" ||
                                              activityValue?.workloadValid ||
                                              isConsultProfile
                                    }
                                    label="Campus"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <AutoCompleteClean
                                    onChange={this.handleCoverageSelectChange}
                                    options={coverageAutoCompleteList}
                                    placeholder="Escola/Curso"
                                    defaultSelected={[selectedCoverage]}
                                    key={selectedCoverage.value}
                                    disabled={
                                        isDACProfile
                                            ? false
                                            : selectedCampus.value === "" ||
                                              activityValue?.workloadValid ||
                                              isConsultProfile
                                    }
                                    label="Escola/Curso"
                                />
                            </Col>
                        </Row>
                        {isStudentsEdit &&
                            studentsForm?.map((student: any, index: number) => (
                                <>
                                    <Row>
                                        <Col>
                                            <AutoCompleteClean
                                                onChange={(e) =>
                                                    this.handleStudentsIdSelectChange(
                                                        e,
                                                        index
                                                    )
                                                }
                                                options={
                                                    studentIdAutoCompletList
                                                }
                                                placeholder="CPF/Passaporte"
                                                defaultSelected={[
                                                    selectedStudentsId[index],
                                                ]}
                                                key={
                                                    selectedStudentsId[index]
                                                        .value
                                                }
                                                extraOptions
                                                label="CPF/Passaporte"
                                                disabled={
                                                    isDACProfile
                                                        ? false
                                                        : isConsultProfile
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <AutoCompleteClean
                                                onChange={(e) =>
                                                    this.handleStudentsNameSelectChange(
                                                        e,
                                                        index
                                                    )
                                                }
                                                options={
                                                    studentNameAutoCompletList
                                                }
                                                placeholder="Estudante"
                                                defaultSelected={[
                                                    selectedStudentsName[index],
                                                ]}
                                                key={
                                                    selectedStudentsId[index]
                                                        .value
                                                }
                                                extraOptions
                                                label="Estudante"
                                                disabled={
                                                    isDACProfile
                                                        ? false
                                                        : isConsultProfile
                                                }
                                            />
                                        </Col>
                                        {isConsultProfile ? null : (
                                            <Col
                                                xs={3}
                                                md={3}
                                                lg={3}
                                                style={{
                                                    display: "flex",
                                                }}
                                            >
                                                {studentsForm.length - 1 ===
                                                    index &&
                                                    studentsBtnAddEnabled && (
                                                        <StyledDefaultButtonLink
                                                            onClick={() =>
                                                                this.handleClickPlusEdit()
                                                            }
                                                            variant="link"
                                                        >
                                                            <PlusIcon />
                                                        </StyledDefaultButtonLink>
                                                    )}
                                                {index > 0 && (
                                                    <StyledDefaultButtonLink
                                                        onClick={() =>
                                                            this.handleClickLessEdit(
                                                                index
                                                            )
                                                        }
                                                        variant="link"
                                                    >
                                                        <LessIcon />
                                                    </StyledDefaultButtonLink>
                                                )}
                                            </Col>
                                        )}
                                    </Row>
                                </>
                            ))}
                        <Row>
                            <Col>
                                <InputLabelTextArea
                                    label="Detalhamento"
                                    value={selectedDetailing}
                                    maxLength={500}
                                    viewLengthInfo
                                    clear
                                    onChange={this.handleTextAreaChangeEdit}
                                    disabled={
                                        isDetailingReadonly || isConsultProfile
                                    }
                                />
                            </Col>
                        </Row>
                    </Container>
                    <div>
                        {isConsultProfile ? (
                            <StyledImportButton
                                style={{ width: 130, marginTop: 24 }}
                                onClick={onHide}
                            >
                                Ok
                            </StyledImportButton>
                        ) : (
                            <StyledImportButton
                                style={{ width: 130, marginTop: 24 }}
                                onClick={() => this.saveSelectedActivity()}
                                disabled={!isFormValidValue}
                            >
                                Confirmar
                            </StyledImportButton>
                        )}
                    </div>
                </Dialog>
                <DialogErrorStudentAssociado
                    open={modalErrorStudentAssociado}
                    onClose={() =>
                        this.handleCloseDialogErrorStudentAssociado()
                    }
                />
                <DialogErrorMessage
                    actionClose={(e: any) =>
                        this.actionCloseDialogErrorMessage(e)
                    }
                    actionHide={() => this.actionHideDialogErroHide}
                    show={showModalError}
                    message={modalErrorText}
                />
            </div>
        );
    }
}
